import React, { useContext, useEffect, useState } from "react"

import VehicleInfoContainer from "../../components/common/VehicleInfoContainer/VehicleInfoContainer"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { ConfirmVehicleLoader } from "../Loaders"
import AppointmentContent from "./AppointmentContent"

interface ValuationProps {
  loading: boolean
  setLoading: (arg0: boolean) => void
}

const Valuation: React.FC<ValuationProps> = ({ loading, setLoading }) => {
  const {
    state: { valuation: { customerValuation } = {} },
  } = useContext(AppContext) as AppContextInterface

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        setLoading(false)
      }, 3000)
    }
    return () => {
      setLoading(false)
    }
  }, [loading, setLoading])

  return !customerValuation && loading ? (
    <ConfirmVehicleLoader />
  ) : (
    <AppointmentContent />
  )
}

const Appointment: React.FC = () => {
  const [updateCondition, setUpdateCondition] = useState(false)
  const [loading, setLoading] = useState(true)

  return (
    <div className="appointment-container">
      <VehicleInfoContainer
        updateCondition={updateCondition}
        setUpdateCondition={setUpdateCondition}
        setLoading={setLoading}
      />
      {updateCondition ? null : (
        <Valuation loading={loading} setLoading={setLoading} />
      )}
    </div>
  )
}

export default Appointment
